module.exports = __webpack_public_path__ + "img/sozial.79fca17c.jpeg";